import React from 'react';
import { Link } from 'react-router-dom';
import '@fortawesome/fontawesome-free/css/all.min.css';
import aboutTeam from '../../assets/images/about/about_team.png';
import ServiceCard from '../Helpers/ServiceCard';
import { useLanguage } from '../../i18n/LanguageContext';
import { trackEvent } from '../../utils/analytics';

const About = () => {
    const { t } = useLanguage();
    const valores = t('about.values');
    return (
        <>
            {/* Hero compacto: intro + imagen difuminada con el fondo */}
            <section className="bg-navy-gradient relative overflow-hidden pt-32 pb-20 min-h-[34rem] flex items-center">
                {/* Foto difuminada hacia el fondo (derecha) */}
                <img
                    src={aboutTeam}
                    alt="Salient"
                    className="pointer-events-none select-none absolute top-[2.5rem] bottom-0 right-0 w-full lg:w-[62%] object-cover"
                    style={{
                        objectPosition: 'center top',
                        maskImage: 'linear-gradient(to right, transparent 0%, #000 42%)',
                        WebkitMaskImage: 'linear-gradient(to right, transparent 0%, #000 42%)',
                    }}
                />
                {/* Refuerzo de degradado para legibilidad del texto */}
                <div className="absolute inset-0 bg-gradient-to-r from-salient-navy via-salient-navy/85 to-transparent"></div>
                <div className="absolute -bottom-40 -left-32 w-[28rem] h-[28rem] bg-salient-primary/15 rounded-full blur-3xl"></div>
                <div
                    className="dot-grid pointer-events-none absolute top-24 left-6 w-32 h-24 opacity-40"
                    style={{ maskImage: 'linear-gradient(135deg,#000,transparent 75%)', WebkitMaskImage: 'linear-gradient(135deg,#000,transparent 75%)' }}
                ></div>

                <div className="contain relative z-10">
                    <div className="max-w-xl" data-aos="fade-right">
                        <span className="inline-block px-4 py-1 rounded-full bg-salient-green/20 border border-salient-green/40 text-salient-green text-sm font-semibold mb-6">
                            {t('about.badge')}
                        </span>
                        <h1 className="text-white font-bold text-4xl md:text-5xl mb-4">{t('about.title')}</h1>
                        <span className="title-underline mb-6"></span>
                        <p className="text-slate-300 text-lg leading-relaxed">
                            {t('about.introBefore')}
                            <span className="text-white font-semibold">{t('about.introBold')}</span>
                        </p>
                        <Link to="/contact" onClick={() => trackEvent('click_cta', { ubicacion: 'quienes_somos' })} className="btn btn-accent mt-8">{t('about.cta')}</Link>
                    </div>
                </div>
            </section>

            {/* Misión, Visión y Valores — fondo claro, lenguaje visual alineado al inicio */}
            <section
                className="relative overflow-hidden py-24"
                style={{ background: 'linear-gradient(180deg, #f8fafc 0%, #eef3f8 100%)' }}
            >
                <div
                    className="dot-grid pointer-events-none absolute top-10 right-8 w-44 h-32 opacity-60 hidden md:block"
                    style={{ maskImage: 'linear-gradient(225deg, #000, transparent 75%)', WebkitMaskImage: 'linear-gradient(225deg, #000, transparent 75%)' }}
                ></div>
                <div className="contain relative z-10">
                    <div className="text-center max-w-2xl mx-auto mb-14" data-aos="fade-up">
                        <h2 className="text-salient-primary font-bold text-4xl mb-4">{t('about.essenceTitle')}</h2>
                        <span className="title-underline mx-auto"></span>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8 items-stretch">
                        <ServiceCard icon="fa-bullseye" title={t('about.missionTitle')} text={t('about.missionText')} titleClass="text-2xl" />
                        <ServiceCard icon="fa-eye" title={t('about.visionTitle')} text={t('about.visionText')} delay={100} titleClass="text-2xl" />
                    </div>

                    {/* Valores */}
                    <div className="relative overflow-hidden bg-white rounded-2xl border border-slate-200/80 shadow-sm p-8 md:p-10 text-center" data-aos="fade-up">
                        <span className="absolute inset-x-0 top-0 h-1.5 bg-gradient-to-r from-salient-green to-salient-primary"></span>
                        <div className="w-16 h-16 rounded-full bg-gradient-to-br from-salient-primary to-salient-primary-hover text-white flex items-center justify-center text-2xl ring-4 ring-salient-green/15 border border-salient-green/30 mb-5 mx-auto">
                            <i className="fas fa-gem"></i>
                        </div>
                        <h3 className="font-heading text-salient-primary font-bold text-2xl mb-3">{t('about.valuesTitle')}</h3>
                        <span className="block w-10 h-1 rounded-full bg-salient-green mb-6 mx-auto"></span>
                        <div className="flex flex-wrap justify-center gap-3">
                            {valores.map((v, i) => (
                                <span
                                    key={i}
                                    className="inline-flex items-center gap-2 rounded-full bg-salient-green/10 border border-salient-green/40 px-4 py-2 text-salient-primary font-medium"
                                >
                                    <span className="w-2 h-2 rounded-full bg-salient-green"></span>
                                    {v}
                                </span>
                            ))}
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default About;
